
















































































import { Fault, FeedTank } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FeedTankFaultDisplay extends Vue {
	@Prop({ required: true, type: Object })
	public feedTank!: FeedTank;

	@Prop({ required: true, type: Array })
	public faults!: Fault[];

	@Prop({ required: true, type: Number })
	public productId!: number;

	@Prop({ required: true, type: Number })
	public index!: number;
}
